import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { v4 as uuidv4 } from 'uuid';
import { ExampleChatQuestion } from '../../pages/ChatPage';

interface ExampleChatQuestionsProps {
  questions: ExampleChatQuestion[];
  onExampleButtonClickedHandler: (question: ExampleChatQuestion) => void;
}

const ExampleChatQuestions: React.FC<ExampleChatQuestionsProps> = ({ questions, onExampleButtonClickedHandler: onButtonClickedHandler }) => {
  return (
    <Box display={'flex'} gap={3} px={4} flexGrow={1} justifyContent={'space-around'} alignItems={'center'}>
      {questions.map((question, index) => (
        <Button 
          sx={{ textTransform: 'none', justifyContent: 'left', textAlign: 'left', fontWeight: "0" }}
          onClick={() => onButtonClickedHandler(question)}
          key={uuidv4()}
        >
          <Card>
            <CardContent>
              <Typography variant="h5" component="h1" gutterBottom mb={1}>
                Example #{index + 1}
              </Typography>
              {question.question}
            </CardContent>
          </Card>
        </Button>
      ))}
    </Box>
  );
};

export default ExampleChatQuestions;